/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */
import { Injectable } from '@angular/core';
import { AppRouter, getInheritedRouteParam, getRouteParam, getRoutePath } from '@gh/common-shared';
import { SupplierUserContext } from '@gh/supplier-shared';
import { first } from 'lodash';
import * as i0 from "@angular/core";
import * as i1 from "@gh/supplier-shared";
import * as i2 from "@gh/common-shared";
var SupplierOfficeActivator = /** @class */ (function () {
    function SupplierOfficeActivator(userContext, router) {
        this.userContext = userContext;
        this.router = router;
    }
    SupplierOfficeActivator.prototype.canActivate = function (route) {
        // if user context is not initialized (in case of error on login) => forbid to open any page
        if (!this.userContext.isInitialized()) {
            return false;
        }
        else if (getRoutePath(route) === '') {
            // if root url => navigate to the first office
            if (this.userContext.offices.length === 1) {
                this.router.navigateByUrl("/offices/" + this.userContext.currentOffice.id + "/purchase-orders");
                return false;
            }
            else if (this.userContext.offices.length > 1) {
                this.router.navigateByUrl("/offices/all/purchase-orders");
                return false;
            }
            else {
                return true;
            }
        }
        else if (route.data.isAcceptInvitation) {
            // if acceptInvitation => navigate to the accepted office
            var officeId = getRouteParam(route, 'officeId');
            if (this.userContext.isOfficeExist(officeId)) {
                this.router.navigateByUrl("/offices/" + officeId + "/purchase-orders");
            }
            else if (this.userContext.offices.length === 1) {
                this.router.navigateByUrl("/offices/" + this.userContext.currentOffice.id + "/purchase-orders");
            }
            else if (this.userContext.offices.length > 1) {
                this.router.navigateByUrl("/offices/all/purchase-orders");
            }
            else {
                this.router.navigateByUrl('');
            }
            return false;
        }
        else {
            var officeId = getInheritedRouteParam(route, 'officeId');
            if (officeId) {
                if (officeId === 'all') {
                    // tslint:disable-next-line:no-non-null-assertion
                    this.userContext.setCurrentOffice(first(this.userContext.offices).id);
                    return true;
                }
                else if (this.userContext.isOfficeExist(officeId)) {
                    this.userContext.setCurrentOffice(officeId);
                    return true;
                }
                else {
                    this.router.navigateByUrl('/404');
                    return false;
                }
            }
            else {
                return true;
            }
        }
    };
    SupplierOfficeActivator.ɵfac = function SupplierOfficeActivator_Factory(t) { return new (t || SupplierOfficeActivator)(i0.ɵɵinject(i1.SupplierUserContext), i0.ɵɵinject(i2.AppRouter)); };
    SupplierOfficeActivator.ɵprov = i0.ɵɵdefineInjectable({ token: SupplierOfficeActivator, factory: SupplierOfficeActivator.ɵfac });
    return SupplierOfficeActivator;
}());
export { SupplierOfficeActivator };
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(SupplierOfficeActivator, [{
        type: Injectable
    }], function () { return [{ type: i1.SupplierUserContext }, { type: i2.AppRouter }]; }, null); })();
